import {Component} from 'react'
import {IoStarSharp, IoOpenOutline} from 'react-icons/io5'
import {MdLocationOn} from 'react-icons/md'
import {BsBriefcaseFill} from 'react-icons/bs'
import Cookies from 'js-cookie'
import Loader from 'react-loader-spinner'
import SimilarJobItem from '../SimilarJobItem'
import Headers from '../Headers'

import './index.css'

const apiStatus = {
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'INPROGRESS',
  initial: 'INITIAL',
}
class JobItemDetails extends Component {
  state = {
    isShowJobItemDetails: apiStatus.initial,
    jobItemDetails: {},
    similarJobItems: [],
  }

  componentDidMount() {
    this.getJobItemDetails()
  }

  getFormattedJobDetails = jobDetails => ({
    id: jobDetails.id,
    companyLogoUrl: jobDetails.company_logo_url,
    companyWebsiteUrl: jobDetails.company_website_url,
    employmentType: jobDetails.employment_type,
    jobDescription: jobDetails.job_description,
    location: jobDetails.location,
    rating: jobDetails.rating,
    title: jobDetails.title,
    packagePerAnnum: jobDetails.package_per_annum,
    lifeAtCompany: {
      description: jobDetails.life_at_company.description,
      imageUrl: jobDetails.life_at_company.image_url,
    },
    skills: jobDetails.skills.map(item => ({
      name: item.name,
      imageUrl: item.image_url,
    })),
  })

  getJobItemDetails = async () => {
    this.setState({
      isShowJobItemDetails: apiStatus.inProgress,
    })
    const {match} = this.props
    const {params} = match
    const {id} = params
    const apiUrl = `https://apis.ccbp.in/jobs/${id}`
    const jwtToken = Cookies.get('jwt_token')
    const options = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    }
    const response = await fetch(apiUrl, options)
    if (response.ok) {
      const jsonData = await response.json()
      const jobDetails = this.getFormattedJobDetails(jsonData.job_details)
      const similarJobs = jsonData.similar_jobs.map(item => ({
        id: item.id,
        title: item.title,
        companyLogoUrl: item.company_logo_url,
        employmentType: item.employment_type,
        jobDescription: item.job_description,
        location: item.location,
        rating: item.rating,
      }))
      this.setState({
        jobItemDetails: jobDetails,
        similarJobItems: similarJobs,
        isShowJobItemDetails: apiStatus.success,
      })
    } else {
      this.setState({isShowJobItemDetails: apiStatus.failure})
    }
  }

  renderJobItemDetailsLoader = () => (
    <div className="loader-container" data-testid="loader">
      <Loader type="ThreeDots" color="#ffffff" height="50" width="50" />
    </div>
  )

  renderJobItemDetailsFailure = () => {
    const retryJobItemDetails = () => this.getJobItemDetails()
    return (
      <div className="jid-failure-view-container">
        <img
          alt="failure view"
          src="https://assets.ccbp.in/frontend/react-js/failure-img.png"
        />
        <h1 className="jid-failure-heading">Oops! Something Went Wrong</h1>
        <p>We cannot seem to find the page you are looking for</p>
        <button
          type="button"
          className="jid-retry-btn"
          onClick={retryJobItemDetails}
        >
          Retry
        </button>
      </div>
    )
  }

  renderJobItemDetailsSucess = () => {
    const {jobItemDetails} = this.state
    const {
      title,
      jobDescription,
      companyWebsiteUrl,
      rating,
      companyLogoUrl,
      location,
      skills,
      lifeAtCompany,
      employmentType,
      packagePerAnnum,
    } = jobItemDetails
    const {imageUrl, description} = lifeAtCompany
    return (
      <div className="jid-bg-container">
        <div className="jid-company-details">
          <img
            alt="job details company logo"
            className="jid-company-logo"
            src={companyLogoUrl}
          />
          <div>
            <h1 className="jid-company-name">{title}</h1>
            <div className="center">
              <IoStarSharp color="#fbbf24" size="30" />
              <p className="jid-company-rating">{rating}</p>
            </div>
          </div>
        </div>
        <div className="space-between ">
          <div className="center">
            <div className="center jid-location-details">
              <MdLocationOn size="20" />
              <p className="jid-location-item">{location}</p>
            </div>
            <div className="center">
              <BsBriefcaseFill size="20" />
              <p className="jid-employment-item">{employmentType}</p>
            </div>
          </div>
          <p className="jid-package-per-annum">{packagePerAnnum}</p>
        </div>
        <hr />
        <div className="jid-description-container">
          <div className="space-between">
            <h1 className="jid-header">Description</h1>
            <a
              href={companyWebsiteUrl}
              className="center anchor-element"
              target="_blank"
              rel="noreferrer"
            >
              Visit
              <IoOpenOutline
                className="link-open-icon"
                size="28"
                color="#b6c5ff"
              />
            </a>
          </div>
          <p className="jid-job-description">{jobDescription}</p>
        </div>
        <div className="skills-container">
          <h1 className="jid-header">Skills</h1>
          <ul className="skills-list">
            {skills.map(item => (
              <li key={item.name} className="center skill-item">
                <img alt={item.name} src={item.imageUrl} />
                <p className="skill-name">{item.name}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className="life-at-company-container">
          <h1 className="jid-header">Life At Company</h1>
          <div className="life-at-company">
            <p className="life-at-company-description">{description}</p>

            <img alt="life at company" src={imageUrl} />
          </div>
        </div>
      </div>
    )
  }

  renderSimilarJobsItem = () => {
    const {similarJobItems} = this.state
    return (
      <ul className="similar-job-list skills-list">
        {similarJobItems.map(item => (
          <SimilarJobItem key={item.id} similarJobItem={item} />
        ))}
      </ul>
    )
  }

  renderJobItemDetails = () => {
    const {isShowJobItemDetails} = this.state
    switch (isShowJobItemDetails) {
      case apiStatus.inProgress:
        return this.renderJobItemDetailsLoader()
      case apiStatus.success:
        return this.renderJobItemDetailsSucess()
      case apiStatus.failure:
        return this.renderJobItemDetailsFailure()
      default:
        return null
    }
  }

  render() {
    return (
      <>
        <Headers />
        <div className="job-item-details-container">
          <div className="job-item-details-content">
            {this.renderJobItemDetails()}
            <div>
              <h1 className="similar-jobs-title">Similar Jobs</h1>
              {this.renderSimilarJobsItem()}
            </div>
          </div>
        </div>
      </>
    )
  }
}
export default JobItemDetails
